import apiClient from './client';

export type UserData = {
  id: number;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  is_internal: boolean | null;
  properties?: Record<string, unknown> | null;
};

type GetUserResponse = {
  success: boolean;
  data: {
    user: UserData;
  } | null;
  error: string | null;
};

export async function getUser(id: number): Promise<GetUserResponse> {
  const response = await apiClient.get<GetUserResponse>(`/user/${id}`);

  return response.data;
}

// Merges the given keys into the user's `properties` JSON bag. A `null` value deletes a key.
// The user can only write their own properties (backend guard: can:update,user).
export async function setUserProperties(
  userId: number,
  properties: Record<string, unknown>,
): Promise<GetUserResponse> {
  const response = await apiClient.post<GetUserResponse>(
    `/users/${userId}/properties`,
    { properties },
  );

  return response.data;
}
